import Keycloak from 'keycloak-js';
import { keycloakBaseUrl, keycloakRealm, keycloakClientId } from '../../env.config';
import { ACTIVE_REFRESH_WINDOW_MS, isUserActive } from './activity';

const keycloak = new Keycloak({
	url: keycloakBaseUrl,
	realm: keycloakRealm,
	clientId: keycloakClientId
});

export default keycloak;

/**
 * Returns the current access token and refreshes it only while the user is active. Background
 * BFF polling must not keep an otherwise idle Keycloak session alive indefinitely.
 */
export async function getValidToken(minValidity = 30): Promise<string | null> {
	if (!keycloak.authenticated) return null;
	try {
		if (isUserActive(ACTIVE_REFRESH_WINDOW_MS)) {
			await keycloak.updateToken(minValidity);
		}
		return keycloak.token ?? null;
	} catch {
		return null;
	}
}
